module.exports = __webpack_public_path__ + "static/user-collection-4580094e7e1e75183658d9cc65bc8335.png";